import React, { Component } from "react";
import "./venta.scss";
import "./Components.css";
import { Col, Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import ItemsCarousel from 'react-items-carousel';
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import Modal from 'react-modal'
import Tabs from "./Components";
const customStylesModal = { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '70%', height: '70%', } };

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class MainProgresoPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      arraySucursales: [],
      id_sucursal: '0',
      date: moment().format('YYYY-MM-DD'),
      typeProduct: 0,
      arrGeneralVentas: [],
      arrDiasVenta: [],
      arrDiasGasto: [],
      totalVentas: {
        kg: 0,
        pesos: 0,
        pesosMesAnterior: 0,
      },
      totalGastos: {
        gastos: 0,
      },
      isLoading: false,
      groupBy: 'sucursal',
      indexViewProducts: -1,

      //Carousel items
      children: [],
      activeItemIndex: 0,

      arrStock: [],
      arrCategorias: [],
      valSeach: '',
      viewTableType: 'KG/PZA.',

      totalEgresoDia: 0,
      totalIngresoDia: 0,
      totalIngresoDiaCitas: 0,
      totalDisponibleVentaGlobal: 0,
      totalDisponibleCitasGlobal: 0,

      viewRegisterCaja: false,
      arrHistoryCaja: [],
      arrRegisterCaja: {
        date: moment().format('YYYY-MM-DD'),
        concepto: 0,
        cantidad: '',
        observacion: '',
      },

      arrListVentaByDay: [],

      vistaFecha: 'normal',
      optTypeView: 'd',
      arrFiltroVer: [
        { optFiltroVer: 'dia', value: 'Día', active: 1, },
        { optFiltroVer: 'semana', value: 'Semana', active: 0, },
        { optFiltroVer: 'mes', value: 'Mes', active: 0, },
      ],
      finit: moment().format('YYYY-MM-DD'),
      ffin: moment().format('YYYY-MM-DD'),
      valueLarge: { min: 1, max: 30 },
      activeTab: 1,
			tabs: [
			{ id : 1, name: 'Home' },
			{ id : 2, name: 'Lista de productos' },
			],


    }
  }

  __getProgreso() {
    this.getProgreso()
  }

  getDateGeneric(opt) {
    if (opt === 0)
      return (new Date())
    else {
      let d = new Date()
      // d.setMonth(5) // Junio
      // d.setDate(30)
      return new Date(d)
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getProgreso()
    this.props.onRef(this)
    // this.getStockAlmacen()
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getAlert() {
    alert('clicked');
  }

  getProgreso() {
    const { id_sucursal, date, typeProduct, groupBy, finit, ffin } = this.state

    const data = {
      user: 'admin',
      tab: this.props.initState.tabProgresoActive,
      id_sucursal,
      // date,
      typeProduct,
      groupBy,
      finit,
      ffin,
    }

    // fetch(this.getURLByOPT('appProgreso'), this.headersPOST({ ...data }))
    //   .then(response => response.json())
    //   .then((response) => {
    //     let { arraySucursales, arrDiasVenta, arrDiasGasto, arrGeneralVentas, } = response
    //     let { total_pesos, total_kg, total_pesos_before, } = arrDiasVenta

        // this.setState({
        //   arraySucursales,
        //   arrDiasVenta: arrDiasVenta.array,
        //   arrDiasGasto: arrDiasGasto.array,
        //   arrGeneralVentas,
        //   totalVentas: {
        //     kg: total_kg,
        //     pesos: total_pesos,
        //     pesosMesAnterior: total_pesos_before,
        //   },
        //   totalGastos: {
        //     gastos: arrDiasGasto.total_gastos
        //   },
        //   isLoading: false,
        // })

        this.goToDay()

      // }).catch((error) => console.log(error));
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout(() => {
      this.getProgreso()
    }, 100)
  }

  getAmountByDay(type) {
    let { date, arrDiasVenta, arrDiasGasto, } = this.state
    const dia = moment(date).format('DD')

    if (arrDiasVenta.length === 0)
      return 0

    // if(typeof arrDiasVenta[ dia - 1 ] === 'undefined')
    //   return this.number_format( 0, 2 );

    if (type === 'venta') {
      return this.number_format(arrDiasVenta[dia - 1].venta_pesos, 2)
    } else if (type === 'gasto') {
      return this.number_format(arrDiasGasto[dia - 1].valor, 2)
    } else if (type === 'utilidad') {
      return this.number_format(arrDiasVenta[dia - 1].venta_pesos - arrDiasGasto[dia - 1].valor, 2)
    }

    return 0
  }

  changeActiveItem(activeItemIndex) {
    this.setState({ activeItemIndex });
  }

  updateState(obj){
    this.setState(obj)
  }

  render() {
    let { arraySucursales, viewVendidoGastoGlobal, viewListCaja, viewRegisterCaja, arrRegisterCaja, arrHistoryCaja,
      totalEgresoDia, totalIngresoDia, totalDisponibleVentaGlobal, totalDisponibleCitasGlobal,
      totalIngresoDiaCitas, arrListVentaByDay, date, totalVentas, arrStock, arrCategorias, valSeach, viewTableType,
      arrFiltroVer, finit, ffin, valueLarge, optTypeView,tabs,activeTab,

      totalGastoVentaGlobal, totalGastoCitasGlobal,
      totalGastoVentaDia, totalGastoCitasDia,
       } = this.state
    const porcMeta = this.getProgressMeta()
    const { RTDirector, signedIn,openMenu } = this.props.initState

    let cantidadDisponible = 0,
      cantidadSalidaDinero = 0,
      cantidadSalidaDineroCitas = 0

    arrHistoryCaja.map((t) => {
      if (t.id_motivo == 4) {
        cantidadSalidaDinero += parseFloat(t.valor) 
      } else if (t.id_motivo == 5) {
        cantidadSalidaDineroCitas += parseFloat(t.valor) 
      } else {
        cantidadDisponible += (t.valor * -1)
      }
    })

    let arrCategoriasFilter = [], arrCitasFilter = [];

    arrCategorias.map((t,e) => {
      if(t.id_categoria !== '60ae75a798d59') {
        arrCategoriasFilter.push(t)
      } else {
        arrCitasFilter.push(t)
      }
    })



    if (!this.state.arrHistoryCaja) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 20, }}>
          <p>Cargando...</p>
        </div>
      )
    }

    return (
      <>
      <div className={`directorPage__wrapper ${(openMenu) ? 'wrapper-left' : '' }`} style={{ backgroundColor: '#fff', borderRadius: '' }}>
        {/* Principal div */}
        <Container style={{paddingTop:'5px'}}>
          <Row>

            <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', }}>

              {
                activeTab==1 ?
                  <div>
                    <h1 style={{ fontWeight: '300', color: '#463132', fontWeight: '500' }}>Dashboard</h1>
                    { (this.state.vistaFecha==='normal') ?
                      <>
                      <Row>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <img style={{ width: 30, height: 30, cursor: 'pointer', float: 'right' }} onClick={() => this.goToDay(0) } src={'img/pos/arrow.png'} />
                        </Col>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <p style={{ textAlign: 'center', fontWeight: '800', fontSize: '1.6rem', margin: 0, }}>
                            { optTypeView === 'm' ? moment(date).format('MM/YYYY') : moment(date).format('DD/MM/YYYY') }
                          </p>
                        </Col>
                        <Col className="ventaPage__colHeader" style={{}}>
                          <img style={{ width: 30, height: 30, cursor: 'pointer', float: 'left', transform: 'rotate(180deg)' }} onClick={() => this.goToDay(1) } src={'img/pos/arrow.png'} />
                        </Col>
                      </Row>
                      <Row>
                        <button className={'btn btn-secondary btn-center-filterday'} onClick={() => { this.setState({ optTypeView: optTypeView === 'm' ? 'd' : 'm', }, this.goToDay) }}>Vista {optTypeView === 'm' ? 'Mes' : 'Día'}</button>
                        <button className={'btn btn-secondary btn-center-filterday'} onClick={() => { this.setState({ vistaFecha: 'avanzada' }, this.goToDay) }}>Vista Avanzada</button>
                      </Row>
                      </>
                    :
                    <>
                    <Row style={{ marginTop: 5, }}>{
                      arrFiltroVer.map((t, e) => (
                        <Col>
                          <p
                            style={{
                              padding: '5px 10px', marginTop: 15, cursor: 'pointer', textAlign: 'center', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0',
                              background: t.active === 1 ? '#2f3447' : 'transparent', border: t.active === 1 ? '0px' : '1px solid #2f3447',
                              color: t.active === 1 ? '#fff' : '#2f3447',
                            }}
                            onClick={() => {
                              this.onChangeFiltroVer(t, e)
                            }} className="regVentaPage__title">{t.value}
                          </p>
                        </Col>
                      ))
                    }</Row>

                    <Row>
                      <Col>
                        <p style={{ margin: 0, }}>Desde</p>
                        <input type={"date"}
                          value={finit}
                          onChange={(event) => {
                            arrFiltroVer.map((t => t.active = 0));
                            this.setState({ finit: event.target.value, arrFiltroVer });
                          }}
                          style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                        />
                      </Col>
                      {
                        arrFiltroVer[0].active != 1 ? (
                          <Col>
                            <p style={{ margin: 0, }}>Hasta</p>
                            <input type={"date"}
                              value={ffin}
                              onChange={(event) => {
                                arrFiltroVer.map((t => t.active = 0));
                                valueLarge.max = event.target.value
                                this.setState({
                                  ffin: event.target.value,
                                  arrFiltroVer,
                                  valueLarge,

                                });
                              }}
                              style={{ background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                            />
                          </Col>
                        ) : null
                      }
                    </Row>
                    <Row>
                      <Col style={{ textAlign: 'right' }}>
                        <button style={{ margin: 0, marginTop: 5, border: 0, background: '#2f3447', }} className={'btn btn-primary'} onClick={() => { this.getProgreso() }}>Generar</button>
                      </Col>
                    </Row>

                    <Row>
                      <button className={'btn btn-secondary btn-center-filterday'} onClick={() => { this.setState({ optTypeView: optTypeView === 'm' ? 'd' : 'm', }, this.goToDay) }}>Vista {optTypeView === 'm' ? 'Mes' : 'Día'}</button>
                      <button className={'btn btn-secondary btn-center-filterday'} onClick={() => { this.setState({ vistaFecha: 'normal' }, this.goToDay) }}>Vista Normal</button>
                    </Row>
                    </>
                  }

                  <Row>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Disponible en caja</b></p>
                      <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.number_format(
                        (totalIngresoDia + totalIngresoDiaCitas) - (cantidadSalidaDinero + cantidadSalidaDineroCitas) + cantidadDisponible
                        , 2)}</b></p>
                    </Col>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Gran total</b></p>
                      <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.number_format(
                        (totalIngresoDia + totalIngresoDiaCitas) - (cantidadSalidaDinero + cantidadSalidaDineroCitas)
                        , 2)}</b></p>
                    </Col>
                  </Row>

                  <Row>
                    <Col onClick={() => { this.getResumenVentaGral('venta') }} className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Ingresos tienda</b></p>
                      <p>
                        <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                          ${this.number_format(totalDisponibleVentaGlobal, 2)}
                        </b>
                        <br />
                        <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                          Rango: ${this.number_format(totalIngresoDia,2)}
                        </b>
                      </p>
                    </Col>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Gasto de tienda</b></p>
                      <p>
                        <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                          ${this.number_format(totalGastoVentaGlobal,2)}
                        </b>
                        <br />
                        <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                          Rango: ${this.number_format(totalGastoVentaDia,2)}
                        </b>
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col onClick={() => { this.getResumenVentaGral('venta') }} className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Ingresos citas</b></p>
                      <p>
                        <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                          ${this.number_format(totalDisponibleCitasGlobal, 2)}
                        </b>
                        <br />
                        <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                          Rango: ${this.number_format(totalIngresoDiaCitas,2)}
                        </b>
                      </p>
                    </Col>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Gasto de citas</b></p>
                      <p>
                        <b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>
                          ${this.number_format(totalGastoCitasGlobal,2)}
                        </b>
                        <br />
                        <b style={{ fontWeight: '400', color: '#777', fontSize: '.8rem' }}>
                          Rango: ${this.number_format(totalGastoCitasDia,2)}
                        </b>
                      </p>
                    </Col>
                  </Row>

                  <Row> 
                    <Col>
                    <div className={'ws__searchcnt'} style={{ marginBottom: '10px', }}>
                      <hr />
                      <b style={{ marginBottom: 10, textAlign: 'center', display: 'block', }}>CAJA</b>
                      <table className="table table-hover table-sm">
                        <thead>
                          <tr>
                            <th >Concepto</th>
                            <th style={{ textAlign: 'center', }}>Hora</th>
                            <th style={{ textAlign: 'center', }}>Cantidad</th>
                            <th style={{ textAlign: 'center', }}>Opciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            arrHistoryCaja.map((t, e) => (
                              <tr key={"item_" + e}>
                                <td>
                                  <p style={{ padding: 0, margin: 0, color: '#000', fontWeight: 600, }}>{t.nombre}</p>
                                  {t.observacion !== '' ? <p style={{ padding: 0, margin: 0, color: '#333', fontWeight: 400, fontSize: '.85rem', whiteSpace: 'pre', }}>{t.observacion}</p> : null}
                                </td>
                                <td style={{ textAlign: 'center', }}><p>{t.hora}</p></td>
                                <td style={{ textAlign: 'center', }}><p>{this.number_format((t.valor * -1), 2)}</p></td>
                                <td style={{ textAlign: 'center', }} onClick={() => { this.setDeleteCaja(t) }}><p style={{ cursor: 'pointer' }}>Eliminar</p></td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                      <hr />
                      <p className={'btn btn-secondary'} onClick={() => { this.setState({ viewRegisterCaja: !viewRegisterCaja, }) }}>Nuevo movimiento en caja</p>
                      {
                        viewRegisterCaja ? (
                          <Row>
                            <Col xs={3}>
                              <select
                                style={{ padding: 5, background: '#f3f3f3', border: 0, }}
                                onChange={(event) => { arrRegisterCaja.concepto = event.target.value; this.setState({ arrRegisterCaja, }) }}
                              >
                                <option value={'0'} disabled={'disabled'} selected={'selected'}>Selecciona un concepto</option>
                                <option value={'1'}>Apertura del día</option>
                                <option value={'2'}>Reingreso en caja</option>
                                {/*<option value={'3'}>Gasto general diario</option>*/}
                                <option value={'4'}>Salida de dinero de tienda</option>
                                <option value={'5'}>Salida de dinero de citas</option>
                              </select>
                            </Col>
                            <Col>
                              <input
                                style={{ width: '100%', padding: 4, background: '#e7e7e7', border: '1px solid #c3c3c3', borderRadius: 4, }}
                                value={arrRegisterCaja.cantidad} placeholder={'Ingresa una cantidad'} type={'number'}
                                onChange={(event) => { arrRegisterCaja.cantidad = event.target.value; this.setState({ arrRegisterCaja }) }}
                              />
                              <input
                                style={{ width: '100%', padding: 4, background: '#e7e7e7', border: '1px solid #c3c3c3', borderRadius: 4, }}
                                value={arrRegisterCaja.date} placeholder={'Ingresa la fecha'} type={'date'}
                                onChange={(event) => { arrRegisterCaja.date = event.target.value; this.setState({ arrRegisterCaja }) }}
                              />
                              {
                                arrRegisterCaja.concepto === '3' ? (
                                  <textarea
                                    placeholder={'Ingresa una observación del retiro'}
                                    onChange={(event) => { arrRegisterCaja.observacion = event.target.value; this.setState({ arrRegisterCaja }); }}
                                    value={arrRegisterCaja.observacion}
                                    style={{ width: '100%', border: 1, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, minHeight: 100, }}
                                  >
                                  </textarea>
                                ) : null
                              }
                            </Col>
                            <Col xs={2}>
                              <p className={'btn btn-secondary'} onClick={() => { this.setRegisterNewCaja() }}>Registrar</p>
                            </Col>
                          </Row>
                        ) : null

                      }
                      <hr />


                    </div>
                    </Col>
                  </Row>
                  </div>
                : activeTab === 2 ?
                <div>
                  <Row>
                    <Col>
                      <button style={{ cursor: 'pointer' }} className={'btn btn-primary'} onClick={() => { this.setState({ viewTableType: viewTableType == 'KG/PZA.' ? 'PESOS' : 'KG/PZA.' }) }}>VISTA: {viewTableType.toUpperCase()}</button>
                    </Col>
                    <Col style={{ textAlign: 'right', }}>
                    </Col>
                  </Row>
                  <hr />

                  <Row>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Nuevas</b></p>
                      <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.number_format(
                        arrCitasFilter.map((t,e) => {
                          let item = t.list.filter((t0) => t0.nombre.toLowerCase() === 'nueva')
                          return item.length > 0 ? item[0].day_venta_pesos : 0
                        })
                        , 2)}</b></p>
                    </Col>
                    <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '0px solid #da3a2f', border: '3px solid rgba(0,0,0,0.2)' }}>
                      <p><b style={{ fontSize: '1.3rem', color: '#555', }}>Seguimientos</b></p>
                      <p><b style={{ fontWeight: '800', color: '#111', fontSize: '1.5rem' }}>${this.number_format(
                        arrCitasFilter.map((t,e) => {
                          let item = t.list.filter((t0) => t0.nombre.toLowerCase() === 'seguimiento')
                          return item.length > 0 ? item[0].day_venta_pesos : 0
                        })
                        , 2)}</b></p>
                    </Col>
                  </Row>

                  <Row>
                    <Col>

                      {
                        arrCategoriasFilter.map((t0, e0) => (
                              (
                                <div className={'ws__list_categorias_almacen'}>
                                  <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t0, e0) }}>
                                    <Col style={{backgroundColor:'#8c6164',aligItems:'center'}}>
                                      <p style={{color:'#fff',fontWeight:'500', margin: 10, }}>{t0.nombre}</p>
                                    </Col>
                                    <Col style={{backgroundColor:'#8c6164'}}>
                                      <p style={{ fontSize: '.8rem', textAlign: 'right', color:'#fff',fontWeight:'500', margin: 10, }}>({this.number_format(t0.list.length, 0)}) productos</p>
                                    </Col>
                                  </Row>

                                  {
                                    t0.show && t0.list.length > 0 ? (
                                      <div className={'ws__searchcnt'}>
                                        <input
                                          className="mt-2 mb-2"
                                          type={'text'}
                                          onChange={(event) => { this.setState({ valSeach: event.target.value }) }}
                                          placeholder={'Buscar un producto...'}
                                          style={{ width: '100%', border: 0, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, }}
                                        />
                                      </div>
                                    ) : null
                                  }

                                  {
                                    t0.show && t0.list.length > 0 && viewTableType === 'KG/PZA.' ? (
                                      <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                          <tr>
                                            <th >Nombre</th>
                                            <th style={{ textAlign: 'center', }}>Adquisiciones de hoy</th>
                                            <th style={{ textAlign: 'center', }}>Ventas de hoy</th>
                                            <th style={{ textAlign: 'center', }}>Existencia</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            t0.list.map((t, e) => (
                                              <>
                                                {
                                                  valSeach === '' ||
                                                    t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                                                    t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                                    <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)} style={{ cursor: 'pointer', }}>
                                                      <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>{this.number_format(t.day_compra_kg, 2)}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>{this.number_format(t.day_venta_kg, 2)}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>{this.number_format(t.history_entradas - t.venta_kg, 2)}</p></td>
                                                      {/*<td style={{ textAlign: 'center', }}><p>{this.number_format((t.compra_kg - t.venta_kg) - t.salida_kg, 2)}</p></td>*/}

                                                    </tr>
                                                  ) : null
                                                }
                                              </>
                                            ))
                                          }
                                        </tbody>
                                      </table>
                                    ) : null
                                  }

                                  {
                                    t0.show && t0.list.length > 0 && viewTableType === 'PESOS' ? (
                                      <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                          <tr>
                                            <th >Nombre</th>
                                            <th style={{ textAlign: 'center', }}>Adquisiciones de hoy</th>
                                            <th style={{ textAlign: 'center', }}>Ventas de hoy</th>
                                            <th style={{ textAlign: 'center', }}>Cantidad global</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {
                                            t0.list.map((t, e) => (
                                              <>
                                                {
                                                  valSeach === '' ||
                                                    t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                                                    t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                                    <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)}>
                                                      <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>${this.number_format(t.day_compra_pesos, 2)}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>${this.number_format(t.day_venta_pesos, 2)}</p></td>
                                                      <td style={{ textAlign: 'center', }}><p>${this.number_format(t.venta_pesos - t.compra_pesos, 2)}</p></td>
                                                    </tr>
                                                  ) : null
                                                }
                                              </>
                                            ))
                                          }
                                        </tbody>
                                      </table>
                                    ) : null
                                  }

                                </div>

                              )
                        ))
                      }
                    </Col>
                  </Row>
                </div>
                : null
              }
            </div>
          </Row>
        </Container>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenViewListDay}
          onRequestClose={() => { this.setState({ isOpenViewListDay: false }) }}
          style={customStylesModal}
          contentLabel=""
        >
          <div className="modalBody__operador">
            <Row className="modalBody__corte">
              <Col>
                <h4>Reporte de venta diaria por producto.</h4>
                <Row>
                  <Col xs={2}>
                    <p>Hora</p>
                  </Col>
                  <Col>
                    <p>Concepto</p>
                  </Col>
                  <Col>
                    <p>KG registrados</p>
                  </Col>
                  <Col>
                    <p>Cantidad compra / venta</p>
                  </Col>
                  <Col>
                    <p>P. Unitario</p>
                  </Col>
                  <Col>
                    <p>Opciones</p>
                  </Col>
                </Row>

                {
                  this.state.isOpenViewListDay && arrListVentaByDay.map((t, e) => (
                    <Row className={'ws__listNthChild'}>
                      <Col xs={2}>
                        <p>{moment(t.fecha).format('HH:mm')}</p>
                      </Col>
                      <Col>
                        <p>{t.type.toUpperCase()}</p>
                      </Col>
                      <Col>
                        <p>{this.number_format(t.kg, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.number_format(t.venta_pesos, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.number_format(t.precio_unitario, 2)}</p>
                      </Col>
                      <Col>
                        <p onClick={() => { this.setDeleteVentaByID(t) }} style={{ cursor: 'pointer', }}>Eliminar</p>
                      </Col>
                    </Row>
                  ))
                }

              </Col>
            </Row>
          </div>
        </Modal>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenViewListVentas}
          onRequestClose={() => { this.setState({ isOpenViewListVentas: false }) }}
          style={customStylesModal}
          contentLabel=""
        >
          <div className="modalBody__operador">
            <Row className="modalBody__corte">
              <Col>
                <h4>Reporte general de compra / venta.</h4>
                <Row>
                  <Col xs={2}>
                    <p>Hora</p>
                  </Col>
                  <Col>
                    <p>Producto</p>
                  </Col>
                  <Col>
                    <p>KG registrados</p>
                  </Col>
                  <Col>
                    <p>Cantidad venta</p>
                  </Col>
                  <Col>
                    <p>P. Unitario</p>
                  </Col>
                </Row>

                {
                  this.state.isOpenViewListVentas && arrListVentaByDay.map((t, e) => (
                    <Row className={'ws__listNthChild'}>
                      <Col xs={2}>
                        <p>{moment(t.fecha).format('HH:mm')}</p>
                      </Col>
                      <Col>
                        <p>{t.nombre.toUpperCase()}</p>
                      </Col>
                      <Col>
                        <p>{this.number_format(t.kg, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.number_format(t.venta_pesos, 2)}</p>
                      </Col>
                      <Col>
                        <p>${this.number_format(t.precio_unitario, 2)}</p>
                      </Col>
                    </Row>
                  ))
                }

                <b>Total: ${this.getCantidadTotal(arrListVentaByDay)}</b>

              </Col>
            </Row>
          </div>
        </Modal>

      </div>
      </>
   );
  }

  getCantidadTotal(arrListVentaByDay) {
    let total = 0;
    for (var a in arrListVentaByDay) {
      total = parseFloat(arrListVentaByDay[a].venta_pesos) + total

      if (a == (arrListVentaByDay.length - 1))
        return this.number_format(total, 2);
    }

  }

  onExpandSectionCate(t, e) {
    let { arrCategorias, } = this.state
    arrCategorias[e].show = !arrCategorias[e].show
    this.setState({ arrCategorias, valSeach: '', })
  }

  setDeleteVentaByID(t) {
    var opcion = window.confirm("¿Estás seguro que deseas eliminar esta orden?");
    if (opcion == true) {
      const { id_produccion, } = t
      fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setDeleteVentaByID", this.headersPOST({ id_produccion, }))
        .then(response => response.json())
        .then((response) => {
          alert('Orden eliminada con éxito')
          this.setState({
            isOpenViewListDay: false,
          })
          this.goToDay()
        })
    }
  }

  setDeleteCaja(t) {
    const { id_corte, } = t

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setDeleteCaja", this.headersPOST({ id_corte, }))
      .then(response => response.json())
      .then((response) => {
        this.goToDay()
        // this.props.mainsetState({ arrProductos: response.arrProductos, });
        // this.setState({ isLoading: false, findProducts: (response.arrProductos.length == 0 ? false : true) })
      })


  }

  onLoadInfoByDay(t, e) {
    // let {
    //   finit, ffin,
    //   indexProducto, indexCategoria, indexSucursal,
    //   arrProductos, arrCategorias, arrSucursales
    // } = this.props.mainState

    let data = {
      id_producto: t.id_producto,
      id_categoria: '',
      id_sucursal: '5f206899a20c8',
      day: t.fecha,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getInfoVentasByDay", this.headersPOST({ ...data, }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          isOpenViewListDay: true,
          arrListVentaByDay: response,
        })
        // console.log(response)
        // this.props.mainsetState({ arrProductos: response.arrProductos, });
        // this.setState({ isLoading: false, findProducts: (response.arrProductos.length == 0 ? false : true) })
      })

  }

  setRegisterNewCaja() {
    const { arrRegisterCaja, } = this.state

    if (arrRegisterCaja.concepto < 1) {
      alert('Por favor, define un concepto.')
      return false
    } else if (arrRegisterCaja.cantidad === '' || arrRegisterCaja.cantidad === 0) {
      alert('Por favor, ingresa una cantidad.')
      return false
    }

    if (arrRegisterCaja.concepto === '3' && arrRegisterCaja.observacion === '') {
      alert('Por favor, registra una observación.')
      return false
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=setRegisterNewCaja", this.headersPOST({ arrRegisterCaja }))
      .then(response => response.json())
      .then((response) => {
        // console.log( response )
        this.setState({
          arrRegisterCaja: {
            date: moment().format('YYYY-MM-DD'),
            concepto: 0,
            cantidad: '',
            observacion: '',
          },
          viewRegisterCaja: false,
        })
        this.goToDay()
      })
  }

  setExportExcel() {
    const { arrStock, date, } = this.state
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=exportExcel", this.headersPOST({ arrStock, date: moment(date).format('DD/MM/YYYY') }))
      .then(response => response.json())
      .then((response) => {
        // console.log( response )
      })
  }

  getResumenVentaGral(type) {
    const { date, } = this.state
    let data = {
      id_sucursal: '5f206899a20c8',
      day: moment(date).format('YYYY-MM-DD'),
      type,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=getResumenVentaGral", this.headersPOST({ ...data }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          isOpenViewListVentas: true,
          arrListVentaByDay: response,
        })
      })
  }

  getStockAlmacen() {
    this.setState({ arrStock: [], arrCategorias: [], })
    const { optTypeView, date, id_sucursal } = this.state
    let opt;
    if (optTypeView === 'm')
      opt = 'month'
    else
      opt = 'day'

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=getStockAlmacen", this.headersPOST({ fecha_init : this.state.finit, fecha_fin: this.state.ffin }))
    .then(response => response.json())
    .then((response) => {
      let { productos, categorias, venta, gasto_venta, venta_citas, gasto_citas, venta_mes, venta_citas_mes} = response
      let gral_day_compra_pesos = 0, gral_day_venta_pesos = 0, gral_existencia_kg = 0,
      gral_existencia_pesos = 0, gral_day_venta_pesos_citas = 0

      productos.map((t) => {
        // cantidadDisponible += ( t.valor * -1 )
        gral_existencia_kg = (((t.compra_kg - t.venta_kg) - t.salida_kg) + gral_existencia_kg)
        gral_existencia_pesos = (((t.compra_pesos - t.venta_pesos) - t.salida_pesos) + gral_existencia_pesos)
        gral_day_compra_pesos = (t.day_compra_pesos + gral_day_compra_pesos)
        // gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)

        if (t.type === 9) {
          gral_day_venta_pesos_citas = (t.day_venta_pesos + gral_day_venta_pesos_citas)
        } else {
          gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)
        }

      })

      let totalEgresoDia = gral_day_compra_pesos
      let totalIngresoDia = gral_day_venta_pesos
      let totalIngresoDiaCitas = gral_day_venta_pesos_citas
      this.setState({
        arrCategorias: categorias, arrStock: productos, totalEgresoDia, totalIngresoDia, totalIngresoDiaCitas,
        totalDisponibleVentaGlobal: venta_mes,
        totalDisponibleCitasGlobal: venta_citas_mes,

        totalGastoVentaGlobal: response.gasto_venta_mes,
        totalGastoCitasGlobal: response.gasto_citas_mes,

        totalGastoVentaDia: response.gasto_venta_dia,
        totalGastoCitasDia: response.gasto_citas_dia,

      })
    })
  }
  


  onInfoBySucursal(t, e) {
    let { tabsArray, arrSucursalSelected } = this.props.initState

    for (var a in tabsArray) {
      tabsArray[a].active = 0
      if (tabsArray[a].index === 2) {
        //Sección sucursal
        tabsArray[a].active = 1
      }
    }
    this.props.initsetState({ arrSucursalSelected: { e, t }, tabsArray, })

  }

  getProgressMeta() {
    let utilidad = this.getAmountByDay('utilidad')
    let meta = 0

    if (utilidad !== 0) {
      utilidad = utilidad.replace('$', '').replace(',', '')
      meta = ((utilidad / 15000) * 100)
    }

    return {
      porc: (meta > 100 ? 100 : meta) + '%',
      val: meta
    }
  }

  goToDay(opt) {
    const { date, arrDiasVenta } = this.state
    let d = new Date(date)

    const dia = moment(date).format('DD')
    const mes = moment(date).format('MM')
    if (opt === 0) {
      //Pa atrás
      let dayAnt = parseInt(dia) - 1
      if (dayAnt < 1) {
        //Ya va para otro mes atrás
        d.setMonth(mes - 2)
        let newDate = new Date(d)
        d.setDate(new Date(moment(newDate).format('YY'), moment(newDate).format('MM'), 0).getDate())

        this.setState({
          isLoading: true,
          arrDiasVenta: [],
          arrDiasGasto: [],
        })

        setTimeout(() => {
          this.setState({
            date: new Date(d),
            dateDire: new Date(d),
          }, this.getProgreso)
        }, 1000)
      } else {
        d.setDate(dayAnt)
        this.setState({
          date: new Date(d),
          dateDire: new Date(d),
        })
      }
    } else if (opt === 1) {
      //Pa adelante
      let dayNext = parseInt(dia) + 1

      if (parseInt(dayNext) > arrDiasVenta.length) {
        return false
      }
      d.setDate(dayNext)
      this.setState({
        date: new Date(d),
        dateDire: new Date(d),
      })
    } else {
    }

    setTimeout(() => {
      // if(this.getAmountByDay('venta') !== '0.00' || this.state.date === moment().format('YYYY-MM-DD')) {
      // this.getProgreso()
      this.getStockAlmacen()
      fetch(this.getURLByOPT('getListadoVentaByDia'), this.headersPOST({ date: this.state.date, groupBy: this.state.groupBy }))
        .then(response => response.json())
        .then((response) => {
          let { arrHistoryCaja, } = response
          this.setState({
            arrHistoryCaja,
          })
        }).catch((error) => console.log(error));

      // }

    }, 500)

  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result; this.seed = function (s, w) { s = parseInt(s, 10).toString(16); return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s; }; result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5); if (en) { result += (Math.random() * 10).toFixed(8).toString(); } return result;
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE', '#A7CDF2', '#E2EFE3', '#8FAEE3', '#F0F4FE', '#A7CDF2', '#E2EFE3', '#8FAEE3']
    return color[e]
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }
  onChangeFiltroVer(t, e) {
    let { arrTableroOptions, arrFiltroVer, isLoading, finit, ffin, valueLarge, } = this.state

    arrFiltroVer.map((t => t.active = 0));
    arrFiltroVer[e].active = 1

    if (t.optFiltroVer == 'dia') {
      finit = moment().format('YYYY-MM-DD')
      ffin = finit
    } else if (t.optFiltroVer == 'semana') {
      let now = moment(finit);
      finit = now.clone().weekday(1).format('YYYY-MM-DD')
      ffin = now.clone().weekday(7).format('YYYY-MM-DD')
    } else if (t.optFiltroVer == 'mes') {
      let now = moment(finit);
      finit = now.startOf('month').format('YYYY-MM-DD')
      ffin = now.endOf('month').format('YYYY-MM-DD')
    }

    this.setState({ arrFiltroVer, finit, ffin }, this.getProgreso);
  }


  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(MainProgresoPage)